import { type InitDomainDto } from 'app/components/domains/types';
import { type InitParticipantDto } from 'app/components/participants/types';
import { MemoryEnum, type ParticipantDto, StorageDto } from 'data';
import { unitSplitter } from './resource-updaters';

export const prepareStorageToRequest = (
  storage: InitParticipantDto['storage'] | InitDomainDto['storage'],
): ParticipantDto['storage'] | InitDomainDto['storage'] => {
  const { size, backupSize, type } = storage;

  return {
    ...storage,
    ...((type === StorageDto.type.POSTGRES && {
      size: unitSplitter(size),
    }) as any),
    ...((type !== StorageDto.type.MEMORY && {
      backupSize: unitSplitter(backupSize),
    }) as any),
  };
};

export const prepareStorageToForm = (
  storage?: ParticipantDto['storage'],
): InitParticipantDto['storage'] | undefined => {
  if (!storage) return storage;

  const { size, backupSize, type } = storage;

  const regExp = /[a-zA-Z]/g;

  return {
    ...storage,
    ...(type === StorageDto.type.POSTGRES && {
      size: {
        value: String(parseFloat(size as string)),
        unit: size?.match(regExp)?.join('') as MemoryEnum,
      },
    }),
    ...((type !== StorageDto.type.MEMORY && {
      backupSize: {
        value: String(parseFloat(backupSize as string)),
        unit: backupSize?.match(regExp)?.join('') as MemoryEnum,
      },
    }) as any),
  };
};
